module.exports = "<p>\r\n  tournament-list works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/main/main-portal/tournaments/tournament-list/tournament-list.component.html
// module id = ../../../../../src/app/main/main-portal/tournaments/tournament-list/tournament-list.component.html
// module chunks = main